var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIconWithoutNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 13.1667H17.3332V14.8334H0.666504V13.1667H2.33317V7.33341C2.33317 5.5653 3.03555 3.86961 4.28579 2.61937C5.53604 1.36913 7.23173 0.666748 8.99984 0.666748C10.7679 0.666748 12.4636 1.36913 13.7139 2.61937C14.9641 3.86961 15.6665 5.5653 15.6665 7.33341V13.1667ZM13.9998 13.1667V7.33341C13.9998 6.00733 13.4731 4.73556 12.5354 3.79788C11.5977 2.8602 10.3259 2.33341 8.99984 2.33341C7.67376 2.33341 6.40199 2.8602 5.4643 3.79788C4.52662 4.73556 3.99984 6.00733 3.99984 7.33341V13.1667H13.9998ZM6.49984 16.5001H11.4998V18.1667H6.49984V16.5001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconWithoutNotification);
export default __webpack_public_path__ + "static/media/BellIconWithoutNotification.dfa455d7f45d9c796e0a154f76506089.svg";
export { ForwardRef as ReactComponent };